const SITE_URL = 'https://codingflash.com';

function setMetaContent(name, content) {
	let meta = document.querySelector(`meta[name='${name}']`);

	if (!meta) {
		meta = document.createElement('meta');
		meta.setAttribute('name', name);
		document.head.appendChild(meta);
	}

	meta.setAttribute('content', content);
}

export function setPageMetadata({
	title,
	description,
	path,
	robots = 'index, follow',
}) {
	document.title = title;
	setMetaContent('description', description);
	setMetaContent('robots', robots);

	let canonical = document.querySelector("link[rel='canonical']");

	if (!canonical) {
		canonical = document.createElement('link');
		canonical.setAttribute('rel', 'canonical');
		document.head.appendChild(canonical);
	}

	canonical.setAttribute('href', `${SITE_URL}${path}`);
}
